import { Box, Hidden, Stack } from 'braid-design-system';
import type React from 'react';

import { DraftListDesktopAndTablet } from 'src/App/components/DraftJobsContent/DraftListDesktopAndTablet';
import { DraftListMobile } from 'src/App/components/DraftJobsContent/DraftListMobile';
import { JobSearchPanel } from 'src/App/components/JobSearchPanel/JobSearchPanel';
import { JobListDesktopAndTablet } from 'src/App/components/JobsContent/JobListDesktopAndTablet';
import { JobListMobile } from 'src/App/components/JobsContent/JobListMobile';
import { Skeleton } from 'src/App/components/Skeleton/Skeleton';
import type { QueryParamTab } from 'src/hooks/useQueryParam';
import { MOCK_DRAFT, MOCK_JOB } from 'src/utils/testData';

const mockDraftJobs = Array(8)
  .fill(undefined)
  .map((_, index) => ({ ...MOCK_DRAFT, id: index.toString() }));

const mockJobs = Array(8)
  .fill(undefined)
  .map((_, index) => ({ ...MOCK_JOB, id: index.toString() }));

interface Props {
  isDraft?: boolean;
  tab: QueryParamTab;
}

export const JobsListLoader: React.FC<React.PropsWithChildren<Props>> = ({
  tab,
}) => {
  const JobsTable = () => (
    <>
      <Hidden below="tablet">
        <JobListDesktopAndTablet loading={true} jobs={mockJobs} tab={tab} />
      </Hidden>

      <Hidden above="mobile">
        <JobListMobile loading={true} jobs={mockJobs} />
      </Hidden>
    </>
  );

  const DraftsTable = () => (
    <>
      <Hidden below="tablet">
        <DraftListDesktopAndTablet loading={true} draftJobs={mockDraftJobs} />
      </Hidden>

      <Hidden above="mobile">
        <DraftListMobile loading={true} draftJobs={mockDraftJobs} />
      </Hidden>
    </>
  );

  return (
    <Box aria-label="Loading">
      <Stack space="medium">
        <JobSearchPanel loading={true} />
        {tab === 'draft' ? <DraftsTable /> : <JobsTable />}
        <Box display="flex" justifyContent="center" paddingTop="xlarge">
          <Skeleton loading numberOfCharacters={50} height={68} />
        </Box>
      </Stack>
    </Box>
  );
};
